import React from 'react';
import { attachLocale, attachCategorySlug, attachSubcategorySlug } from '../../../../lib/utils';
import ShopsGrid from '../shared/ShopsGrid';
import ChevronLeft from '../../../svgs/ChevronLeft';
import {
  getAllCategoryAnalyticsSlug,
  getBrowseCategoriesLevelThreeAnalytics,
} from '../NavigationCategoriesBar/levelThreeBrowseCategoriesAnalytics';
import {
  LightLinkAnchor,
  BoldTitleSpan,
  ImgAlignLeftSpan,
  CategoryHeaderDiv,
  ImgAlignTopSpan,
  BackButtonTitleSpan,
  MenuItemContainer,
  BorderedMenuItemContainerTop,
  LightButton,
} from './MobileMenuStyles';
import { DATA_TRACK_TYPE_INTERNAL } from '../../../../lib/constants';

const MobileMenuViewThree = (props) => {
  const {
    subCategories = [],
    shops = [],
    locale,
    parentCategorySlug,
    parentCategoryAnalyticsSlug,
    parentCategoryName,
    backButtonOnClick,
    globalPageConfig = {},
    setFocusButton,
    theme
  } = props;

  if (!subCategories || !subCategories.length) {
    return null;
  }

  let resolvedParentCategorySlug = attachCategorySlug(parentCategorySlug);
  resolvedParentCategorySlug = attachLocale(resolvedParentCategorySlug, locale);

  const { categoryDirectoryParentCategoryPrefix = 'All', backToCategoriesButtonText } = globalPageConfig;

  const parentTrack = getBrowseCategoriesLevelThreeAnalytics({
    analyticsSlug: getAllCategoryAnalyticsSlug(parentCategoryAnalyticsSlug),
    parentCategoryAnalyticsSlug,
    url: resolvedParentCategorySlug,
  });

  const parentCategoryComponent = (
    <MenuItemContainer>
      <LightLinkAnchor
        href={parentTrack.url}
        id={parentTrack.dataTrackingId}
        data-track-id={parentTrack.dataTrackingId}
        data-track-click={parentTrack.dataTrack}
        data-track-type={DATA_TRACK_TYPE_INTERNAL}>
        <BoldTitleSpan>{`${categoryDirectoryParentCategoryPrefix} ${parentCategoryName}`}</BoldTitleSpan>
      </LightLinkAnchor>
    </MenuItemContainer>
  );

  const subCategoriesList = subCategories.map((cat) => {
    const {
      slug = '',
      analyticsSlug = '',
      name = '',
    } = cat;

    let resolvedSubCategorySlug = attachSubcategorySlug(parentCategorySlug, slug);
    resolvedSubCategorySlug = attachLocale(resolvedSubCategorySlug, locale);

    const track = getBrowseCategoriesLevelThreeAnalytics({
      analyticsSlug,
      parentCategoryAnalyticsSlug,
      url: resolvedSubCategorySlug,
    });

    const {
      dataTrackingId,
      dataTrack,
      url,
    } = track;

    return (
      // check if the name start with space so that we don't display placeholder subcategories and show empty link
      !name.startsWith(' ')
        ? (
          <MenuItemContainer>
            <LightLinkAnchor
              key={name}
              id={dataTrackingId}
              data-track-id={dataTrackingId}
              data-track-click={dataTrack}
              data-track-type={DATA_TRACK_TYPE_INTERNAL}
              href={url}>
              <BoldTitleSpan>{name}</BoldTitleSpan>
            </LightLinkAnchor>
          </MenuItemContainer>
        ) : null
    );
  });

  const shopsComponent = shops?.length ? (
    <ShopsGrid
      locale={locale}
      parentCategoryAnalyticsSlug={parentCategoryAnalyticsSlug}
      shops={shops} />
  ) : null;

  const backTrack = getBrowseCategoriesLevelThreeAnalytics({
    analyticsSlug: 'back-to-categories',
    parentCategoryAnalyticsSlug,
  });

  const backButton = (
    <BorderedMenuItemContainerTop>
      <LightButton
        onClick={backButtonOnClick}
        innerRef={(element) => element && setFocusButton(3, element.id, false)}
        id="mobile-back-3"
        data-track-id={backTrack.dataTrackingId}
        data-track-click={backTrack.dataTrack}
        data-track-type={DATA_TRACK_TYPE_INTERNAL}
      >
        <ImgAlignTopSpan>
          <ImgAlignLeftSpan>
            <ChevronLeft fill={theme.c.icon.interactive} />
          </ImgAlignLeftSpan>
        </ImgAlignTopSpan>
        <BackButtonTitleSpan>
          {backToCategoriesButtonText}
        </BackButtonTitleSpan>
      </LightButton>
    </BorderedMenuItemContainerTop>
  );

  const parentCategoryHeader = (
    <CategoryHeaderDiv>
      {parentCategoryName}
    </CategoryHeaderDiv>
  );

  return (
    <div>
      {backButton}
      {parentCategoryHeader}
      {parentCategoryComponent}
      {subCategoriesList}
      {shopsComponent}
    </div>
  );
};

export default MobileMenuViewThree;
